(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insight-preorder"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var modal      = document.getElementById('insight-mount-modal');
  var ctaBtn     = document.querySelector('[data-insight-cta]');
  var closeBtn   = document.querySelector('[data-insight-modal-close]');
  var addBtn     = document.querySelector('[data-insight-add-to-cart]');
  var totalEl    = document.querySelector('[data-insight-total]');
  var radios     = document.querySelectorAll('input[name="insight_mount"]');
  var previewBox = document.querySelector('[data-mount-preview]');
  var engoCheck  = document.querySelector('input[name="insight_engo"]');
  var BASE_PRICE = 589;
  var translationsEl = document.querySelector('[data-insight-translations]');
  var translations = translationsEl ? JSON.parse(translationsEl.textContent) : {};
  function t(key, vars) {
    var value = translations[key] || key;
    Object.keys(vars || {}).forEach(function (name) {
      value = value.replace(new RegExp('\\{\\{\\s*' + name + '\\s*\\}\\}', 'g'), String(vars[name]));
    });
    return value;
  }

  // Guard: exit silently if section is not on the page
  if (!modal || !ctaBtn) return;

  // --- Open modal ---
  ctaBtn.addEventListener('click', function () {
    modal.showModal(); // showModal() — NOT show() — required for focus trap + Esc key
  });

  // --- Close button ---
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      modal.close();
    });
  }

  // --- Close on backdrop click ---
  modal.addEventListener('click', function (e) {
    if (e.target === modal) modal.close();
  });

  // --- Recalculate total from mount + optional ENGO 3 ---
  function updateTotal() {
    var selectedRadio = document.querySelector('input[name="insight_mount"]:checked');
    var mountPrice = selectedRadio ? (parseFloat(selectedRadio.dataset.mountPrice) || 0) : 0;
    var engoPrice = (engoCheck && engoCheck.checked) ? (parseFloat(engoCheck.dataset.addonPrice) || 0) : 0;
    var total = BASE_PRICE + mountPrice + engoPrice;
    if (totalEl) totalEl.textContent = '€' + Math.round(total);
  }

  // --- Show mount preview image ---
  function showMountPreview(imgKey) {
    if (!previewBox) return;
    previewBox.hidden = false;
    previewBox.querySelectorAll('.insight-mount-preview__img').forEach(function (img) {
      img.hidden = (img.dataset.mountImg !== imgKey);
    });
  }

  // --- Mount selection: update total price + show preview + enable add-to-cart ---
  var variantPanels = document.querySelectorAll('[data-mount-variants]');

  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      updateTotal();
      showMountPreview(this.dataset.mountImgKey);

      variantPanels.forEach(function (p) { p.hidden = true; });

      if (this.dataset.hasVariants === 'true') {
        var panel = this.closest('li').querySelector('[data-mount-variants]');
        if (panel) {
          panel.hidden = false;
          addBtn.disabled = true;
        }
      } else {
        if (addBtn) addBtn.disabled = false;
      }
    });
  });

  // --- ENGO 3 add-on: choose one valid Lens & Style variant ---
  var engoPanel = document.querySelector('[data-engo-variants]');
  var engoPreview = document.querySelector('[data-engo-preview]');
  var engoPreviewImg = document.querySelector('[data-engo-preview-img]');
  var engoVariantButtons = document.querySelectorAll('[data-engo-variant-id]');

  function selectEngoVariant(button) {
    if (!button || button.disabled) return;
    engoVariantButtons.forEach(function (candidate) {
      candidate.classList.toggle('is-active', candidate === button);
    });
    var price = parseFloat(button.dataset.engoVariantPrice) || 0;
    var title = button.dataset.engoVariantTitle || '';
    if (engoCheck) {
      engoCheck.value = button.dataset.engoVariantId;
      engoCheck.dataset.addonPrice = price;
    }
    if (engoPreviewImg && button.dataset.engoVariantImage) {
      engoPreviewImg.src = button.dataset.engoVariantImage;
      engoPreviewImg.alt = t('engo_variant_alt', { style: title });
    }
    var priceEl = document.querySelector('.insight-addon__price');
    if (priceEl) priceEl.textContent = '+ €' + price.toFixed(0);
    updateTotal();
  }

  if (engoCheck) {
    engoCheck.addEventListener('change', function () {
      var checked = this.checked;
      if (engoPanel) engoPanel.hidden = !checked;
      if (engoPreview) engoPreview.hidden = !checked;
      if (checked) {
        var selected = document.querySelector('[data-engo-variant-id].is-active') || engoVariantButtons[0];
        selectEngoVariant(selected);
      }
      updateTotal();
    });
  }

  engoVariantButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      selectEngoVariant(this);
    });
  });

  // --- Variant size buttons ---
  document.querySelectorAll('.insight-mount-variants__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = this.closest('.insight-mount-variants');
      panel.querySelectorAll('.insight-mount-variants__btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      this.classList.add('is-active');

      var radio = this.closest('li').querySelector('input[type="radio"]');
      if (radio) {
        radio.value = this.dataset.variantId;
        radio.dataset.mountPrice = this.dataset.variantPrice;
        updateTotal();
      }
      if (addBtn) addBtn.disabled = false;
    });
  });

  // --- Add to cart: two line items via AJAX ---
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var selectedRadio = document.querySelector('input[name="insight_mount"]:checked');
      if (!selectedRadio) return;

      var altimeterId = parseInt(addBtn.dataset.altimeterVariant, 10);
      var mountId     = parseInt(selectedRadio.value, 10);

      if (!altimeterId || !mountId) {
        console.error(t('missing_variant', { altimeter: altimeterId, mount: mountId }));
        return;
      }

      var items = [
        { id: altimeterId, quantity: 1 },
        { id: mountId,     quantity: 1 }
      ];

      // Include ENGO 3 if checked
      if (engoCheck && engoCheck.checked) {
        var engoId = parseInt(engoCheck.value, 10);
        if (engoId) items.push({ id: engoId, quantity: 1 });
      }

      var originalLabel = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = t('adding');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) {
        // Check HTTP status — fetch resolves even on 422/500
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.message || t('cart_error', { status: res.status }));
          });
        }
        return res.json();
      })
      .then(function () {
        modal.close();
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('Insight cart error:', err);
        addBtn.disabled = false;
        addBtn.textContent = originalLabel;
      });
    });
  }

  // --- Floating CTA: show when hero button is out of view ---
  var floatingCta = document.querySelector('[data-floating-cta]');
  var floatingBtn = document.querySelector('[data-floating-cta-btn]');

  if (floatingCta && ctaBtn) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        floatingCta.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    observer.observe(ctaBtn);

    if (floatingBtn) {
      floatingBtn.addEventListener('click', function () {
        modal.showModal();
      });
    }
  }

  // --- Gallery navigation ---
  var galleryTrack = document.querySelector('[data-gallery-track]');
  var galleryPrev  = document.querySelector('[data-gallery-prev]');
  var galleryNext  = document.querySelector('[data-gallery-next]');
  var galleryDots  = document.querySelector('[data-gallery-dots]');

  if (galleryTrack && galleryDots) {
    var items = galleryTrack.querySelectorAll('.insight-gallery__item');
    var currentIndex = 0;

    // Build dots
    items.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'insight-gallery__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', t('go_to_image', { index: i + 1 }));
      dot.addEventListener('click', function () { scrollToIndex(i); });
      galleryDots.appendChild(dot);
    });

    function scrollToIndex(idx) {
      if (idx < 0) idx = items.length - 1;
      if (idx >= items.length) idx = 0;
      currentIndex = idx;
      items[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      updateDots();
    }

    function updateDots() {
      galleryDots.querySelectorAll('.insight-gallery__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === currentIndex);
      });
    }

    // Detect scroll position to update dots
    var scrollTimer;
    galleryTrack.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var trackRect = galleryTrack.getBoundingClientRect();
        var center = trackRect.left + trackRect.width / 2;
        var closest = 0;
        var closestDist = Infinity;
        items.forEach(function (item, i) {
          var rect = item.getBoundingClientRect();
          var itemCenter = rect.left + rect.width / 2;
          var dist = Math.abs(itemCenter - center);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        currentIndex = closest;
        updateDots();
      }, 80);
    });

    if (galleryPrev) galleryPrev.addEventListener('click', function () { scrollToIndex(currentIndex - 1); });
    if (galleryNext) galleryNext.addEventListener('click', function () { scrollToIndex(currentIndex + 1); });
  }

}());

  } catch(e) { console.error(e); }
})();
})();
